/* tslint:disable:object-literal-sort-keys */
import { SpacingTheme, SpacingThemeNumber } from '@kite-js/theme-types';

export const spacingNumber: SpacingThemeNumber = {
    XXXXL: 64,
    XXXL: 48,
    XXL: 32,
    XL: 24,
    L: 16,
    M: 12,
    S: 8,
    XS: 4,
    NONE: 0,
};

export const spacing: SpacingTheme = {
    XXXXL: `${spacingNumber.XXXXL}px`,
    XXXL: `${spacingNumber.XXXL}px`,
    XXL: `${spacingNumber.XXL}px`,
    XL: `${spacingNumber.XL}px`,
    L: `${spacingNumber.L}px`,
    M: `${spacingNumber.M}px`,
    S: `${spacingNumber.S}px`,
    XS: `${spacingNumber.XS}px`,
    NONE: `${spacingNumber.NONE}`,
};
